export default __webpack_public_path__ + "static/media/facestab.8810b5f8.png";